import sortAlphabeticallyAscByTitle from 'components/shared/mixins/sorting/sortAlphabeticallyAscByTitle'
import sortAlphabeticallyDescByTitle from 'components/shared/mixins/sorting/sortAlphabeticallyDescByTitle'
import sortByCertificationDateAsc from 'components/shared/mixins/sorting/sortByCertificationDateAsc'
import sortByCertificationDateDesc from 'components/shared/mixins/sorting/sortByCertificationDateDesc'

export default {
    mixins: [
        sortAlphabeticallyAscByTitle,
        sortAlphabeticallyDescByTitle,
        sortByCertificationDateAsc,
        sortByCertificationDateDesc
    ],
    computed: {
        orders () {
            return [
                { value: 'alphabeticallyAsc', label: this.$t('CollectionFilter.alpha_order_asc'), func: this.sortAlphabeticallyAsc },
                { value: 'alphabeticallyDesc', label: this.$t('CollectionFilter.alpha_order_desc'), func: this.sortAlphabeticallyDesc },
                { value: 'byDateNewest', label: this.$t('CollectionFilter.from_new_to_old'), func: this.sortByDateAsc },
                { value: 'byDateOldest', label: this.$t('CollectionFilter.from_old_to_new'), func: this.sortByDateDesc },
            ]
        }
    },
    data () {
        return {
            sorting: 'byDateNewest'
        }
    },
    methods: {
        getSortingFunction () {
            return this.orders.find(order => order.value === this.sorting).func
        },
        selectSorter (val) {
            if (val === null) {
                this.sorting = 'byDateNewest'
            } else {
                this.sorting = val
            }
            this.$emit('sorting-changed', this.getSortingFunction())
        },
    },
    created () {
        this.$emit('sorting-changed', this.getSortingFunction())
    }
}
